/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import PropTypes from 'prop-types';

import context from '../../../../../../context/auth-context';
import Spinner from '../../../../../UI/Spinner/Spinner';

const Notifications = () => {

    const [currentState, modifyState] = useState({
        notifications: null,
        error: false
    });

    const authContext = useContext(context);
    let notifications = currentState.error ? <span className="badge badge-danger">Could not fetch notifications</span> : <Spinner />;

    useEffect(() => {
        if (authContext.tokenIsValid) {
            axios.get(`/users/events/${authContext.userId}/${authContext.companyId}/${authContext.companyCode}`).then(response => {
                modifyState({
                    notifications: response.data,
                    error: false
                });
            }).catch(error => {
                modifyState({ error: error.message });
            })
        }
        return () => modifyState({ notifications: null });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authContext.companyId, authContext.tokenIsValid]);

    if (!currentState.error && currentState.notifications) {
        notifications = currentState.notifications;
    }

    return (
        <li className="nav-item dropdown">
            <span className="nav-link" data-toggle="dropdown" title="Notifications" aria-expanded="false" data-animation="scale-up" role="button" style={{ cursor: 'pointer' }}>
                <i className="icon md-notifications" style={{fontSize: '1.3em', marginTop: '2px'}} aria-hidden="true"></i>
                <span className={`badge badge-pill badge-${currentState.error || notifications.length > 0 ? 'danger' : 'secondary'} up`}>{!currentState.error ? notifications.length : 'Error'}</span>
            </span>
            <div className="dropdown-menu dropdown-menu-right dropdown-menu-media" role="menu">
                <div className="dropdown-menu-header">
                    <h5>NOTIFICATIONS</h5>
                    {notifications.length > 0 ? <span className="badge badge-round badge-danger">{`${notifications.length} New`}</span> : null}
                </div>

                <div className="list-group">
                    <div data-role="container">
                        <div data-role="content">
                            {
                                !currentState.error && currentState.notifications ? (
                                    notifications.length > 0 ? notifications.map(notification => {
                                        return (
                                            <Link to="#" key={notification.id} className="list-group-item dropdown-item" role="menuitem">
                                                <div className="media">
                                                    <div className="pr-10">
                                                        <i className="icon md-notifications-active bg-red-600 white icon-circle" aria-hidden="true"></i>
                                                    </div>
                                                    <div className="media-body">
                                                        <h6 className="media-heading">{notification.alert}</h6>
                                                        <time className="media-meta">{notification.eventdate}</time>
                                                    </div>
                                                </div>
                                            </Link>
                                        );
                                    }) : <span className="badge badge-warning" style={{ width: '100%' }}>No new notifications</span>
                                ) : notifications
                            }
                        </div>
                    </div>
                </div>
                <div className="dropdown-menu-footer">
                    <Link to="#" className="dropdown-item" role="menuitem">
                        {authContext.companyName ? authContext.companyName.toUpperCase() : null}
                    </Link>
                </div>
            </div>
        </li>
    );

};

Notifications.propTypes = {
    companyCode: PropTypes.string,
    userId: PropTypes.number
}

export default Notifications;